import styled, { css } from 'styled-components';

const sharedStyles = css`
    display: flex;
    margin-bottom: 0.7rem;
`;

export const LandingPageFilterAndLastUpdated = styled.div`
    ${sharedStyles}
    justify-content: space-between;
    padding-top: 0.4rem;
`;

export const LandingPageLastUpdated = styled.div`
    ${sharedStyles}
    justify-content: flex-end;
`;
